module.exports = __webpack_public_path__ + "img/icon_microsoft.5bd0e45f.svg";